import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import update from 'react-addons-update';
import {sum, getImageUrlForProduct, getProductImageUrl} from '../utils'


function getProductImages(p) {
    var images = p.images || [];
    if (p.children) images = images.concat(...p.children.map(child => child.images || []));
    return images;
}

export class PurchaseModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.onConfirm = this.onConfirm.bind(this);

        var product = this.props.product;
        var moqs = (!product.is_parent ? [product] : product.children).reduce((prev, curr) => {
            if (curr.stock > 0) prev[curr.sku] = product.is_parent ? 0 : curr.moq;
            return prev;
        }, {});

        var quantities = Object.assign({}, moqs);
        this.state = {moqs, quantities};
    }
    handleCancel () {
        this.refs.modal.close();
    }
    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }
    onQuantityChange(event, sku) {
        var quantity = event.target.value;
        if (!quantity) quantity = null;
        else quantity = parseInt(quantity);
        if (isNaN(quantity) || quantity < 0) return;
        this.setState({quantities: Object.assign({}, this.state.quantities, {[sku]: quantity})});
    }
    render () {
        var product = this.props.product;
        var products = product.is_parent ? product.children : [product];
        var variableColor = product.is_parent && product.attributes.variables.indexOf('color') !== -1;
        var variableSize = product.is_parent && product.attributes.variables.indexOf('size') !== -1;

        return (
            <BootstrapModal
                ref="modal"
                className="add-to-cart"
                confirm="Add to Cart"
                cancel="Cancel"
                onCancel={this.handleCancel}
                onConfirm={this.onConfirm}
                onHidden={this.props.onHidden}
                title={ product.is_parent ? 'Select Options' : 'Add to Cart'}>
                { this.state.errors ?
                    <div className="text-danger">
                        <ul>
                            {  this.state.errors.map((err, i) => <li key={i}>{ err }</li>) }
                        </ul>
                    </div>
                        : null
                }
                <table className="table" style={{fontSize: 13}}>
                    <thead>
                        <tr>
                            <th>Item No.</th>
                            <th>Image</th>
                            <th>Color</th>
                            <th>Size</th>
                            <th>Weight</th>
                            <th>Price</th>
                            <th>MOQ</th>
                            <th style={{width: '6em'}}>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            products.map((p, i) => (
                                <tr key={ p.sku }>
                                    <td>{ p.sku }</td>
                                    <td className="image">
                                        {getImageUrlForProduct(p) ? <img src={ getImageUrlForProduct(p, 'sm') } /> : null}
                                        {getImageUrlForProduct(p) ? <img className="hover-content" src={ getImageUrlForProduct(p, 'lg') } /> : null}
                                    </td>
                                    <td>{ p.attributes ? p.attributes.color : null }</td>
                                    <td>{ p.attributes ? p.attributes.size : null }</td>
                                    <td>{ p.weight }</td>
                                    <td>{ p.stock > 0 ? '$' + p.unit_price : '-' }</td>
                                    <td>{ p.moq }</td>
                                    <td>{p.stock > 0 ?
                                        <input type="text" className="form-control form-control-sm" value={ this.state.quantities[p.sku] } onChange={event => this.onQuantityChange(event, p.sku)} style={{fontSize: 13}} /> : 'Out of Stock'}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </BootstrapModal>
        );
    }
    openModal () {
        this.refs.modal.open();
    }
    onConfirm () {
        var data = this.state.quantities;
            /*        data = Object.keys(data).map(sku => [sku, data[sku] || 0])
            .filter(kvp => kvp[1] > 0)
            .reduce(
                (prev, curr) => {
                    prev[curr[0]] = curr[1];
                    return prev;
                }, {}
            );*/
        var lessThanMOQ = Object.keys(data).filter(sku => data[sku] && data[sku] < this.state.moqs[sku]);
        if (lessThanMOQ.length > 0) {
            this.setState({errors: lessThanMOQ.map(sku => sku + ': quantity less than Minimum Order Quantity.')});
            return;
        }

        var quantity = sum(Object.keys(data).map(sku => data[sku] || 0));
        this.xhr = $.postJSON('/cart/add_products', data)
        // the returned value of .then is a jQuery Promise which does not have .abort method.
        // So, .done, .fail shall be used here.
            .done(() => {
                this.refs.modal.close()
                this.props.onItemsAdded && this.props.onItemsAdded(quantity);
            }).fail((xhr, textStatus, errorThrown) => {
                if (xhr.status === 400) {
                    this.setState(xhr.responseJSON)
                } else if (xhr.status === 401) {
                    this.setState({errors: ['You have not logged in. Please log in again.']});
                } else {
                    // status code 0:
                    //   1. doing cross-site scripting (where access is denied)
                    //   2. requesting a URL that is unreachable (typo, DNS issues, etc).
                    //   3. connection is reset.
                    //   4. xhr.abort is called. xhr.abort will cause connection abort and .fail and .always be called with status code 0.
                    this.setState({errors: ['Operation failed.']})
                }
            }).always((xhr, textStatus, errorThrown) => {
                this.xhr = null
            });
    }

}

export class ProductImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
        };
        this.handleCancel = this.handleCancel.bind(this);
    }
    handleCancel () {
        this.refs.modal.close();
    }
    handleHover(i) {
        this.setState({selected: i});
    }
    openModal () {
        this.refs.modal.open();
    }
    render() {
        var product = this.props.product;
        var images = getProductImages(this.props.product);
        return (
            <BootstrapModal
                ref="modal"
                className="image-modal product-image-modal"
                backdrop={true}
                onHidden={this.props.onHidden}
                onCancel={this.handleCancel}
                title={ product.name }>
                <div className="sidebar">
                    { images.map((img, i) => <img key={img} className={this.state.selected === i ? 'selected' : ''} onMouseEnter={() => this.handleHover(i)} src={ getProductImageUrl(img, 'sm') } />) }
                </div>
                <img src={getProductImageUrl(images[this.state.selected], 'lg')} />
            </BootstrapModal>
        );
    }
}
